import { render } from "./SoaTree.vue?vue&type=template&id=e566a114&scoped=true"
import script from "./SoaTree.js?vue&type=script&lang=js"
export * from "./SoaTree.js?vue&type=script&lang=js"

import "./SoaTree.vue?vue&type=style&index=0&id=e566a114&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e566a114"]])

export default __exports__